// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"ecb34d2d","488":"b2921de3","960":"febd6247"}[chunkId] + ".chunk.js";
};